import React, { createContext } from "react";

export const StateContext = createContext(); //Creates a context

export default ({ children, state }) => {
  return (
    <StateContext.Provider value={state}>{children}</StateContext.Provider>
  );
};
